/* External */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import { CommonClassNames } from '@dtvgo/classnames';

/* Styles */
import './ConditionalVisible.scss';

const ConditionalVisibleClassNames = CommonClassNames.component('conditional-visible-v2');
const DEFAULT_TRANSITION_SECONDS = 1;

function ConditionalVisible({
  className = '',
  style,
  visible = false,
  transitionSeconds,
  children,
}) {
  const [displayed, setDisplayed] = useState(visible);

  const innerStyle = useMemo(() => {
    if (!transitionSeconds) return style;

    return {
      ...style,
      transitionDuration: `${transitionSeconds}s`,
    };
  }, [style, transitionSeconds]);

  useEffect(() => {
    let timeout;
    if (visible) {
      setDisplayed(true);
    } else {
      timeout = setTimeout(() => {
        setDisplayed(false);
      }, (transitionSeconds || DEFAULT_TRANSITION_SECONDS) * 1000);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [transitionSeconds, visible]);

  return (
    <div
      className={ConditionalVisibleClassNames.block({
        visible,
        displayed: visible || displayed,
      }, className)}
      style={innerStyle}
    >
      {children}
    </div>
  );
}

ConditionalVisible.propTypes = {
  className: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.string),
  visible: PropTypes.bool,
  transitionSeconds: PropTypes.number,
  children: PropTypes.node,
};

ConditionalVisible.defaultProps = {
  className: '',
  style: {},
  visible: false,
  transitionSeconds: 0,
  children: null,
};

export default ConditionalVisible;
